import { createPortal } from "@app/shared/utils";

export const cookiePreferencesPortal = createPortal("cookiePreferences");

export function openCookiePreferences() {
  cookiePreferencesPortal.open();
}

export function closeCookiePreferences() {
  cookiePreferencesPortal.close();
}
